import { render } from "./IconChevronRight.vue?vue&type=template&id=44aa4d33&ts=true"
import script from "./IconChevronRight.vue?vue&type=script&lang=ts"
export * from "./IconChevronRight.vue?vue&type=script&lang=ts"

import "./IconChevronRight.vue?vue&type=style&index=0&id=44aa4d33&lang=scss"

import exportComponent from "C:\\BuildAgent\\work\\e394cd1ec4c7054f\\src\\TicketSolutions.Personalisation.Client\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__